module.exports = __webpack_public_path__ + "bda1d43f4d722f347dd60e4a0f5514bd.png";